import dayjs from 'dayjs';
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { getLocalStorage } from 'services/common/storage';
import { LOCAL_STORAGE } from 'utils/constants';

export const getCurrentLanguage = () => getLocalStorage(LOCAL_STORAGE.LANGUAGE) || 'vi';

export const i18ChangeLanguage = (language: string) => {
  i18n.changeLanguage(language);
  dayjs.locale(language);
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${process.env.REACT_APP_API_BASE_URL}fe-translations?locale={{lng}}`,
    },
  });

export default i18n;
